module.exports = __webpack_public_path__ + "img/0_4.9df0a874.png";